import React, { useMemo, useContext, useRef } from 'react';
import { useThrottledLoading } from '../../hooks/use-throttled-loading/index.js';
import { SelectListBox } from './select.styles.js';
import { SelectContext } from './use-select-state.js';
export const SelectListBoxComponent = () => {
    const { state, props } = useContext(SelectContext).selectState;
    const { loading, dataAutomation, onScrollRevealLastItem, emptyState, listBoxLabel, filterInput, } = props;
    const { listState, listId } = state;
    const options = useMemo(() => Array.from(listState.collection), [listState.collection]);
    const { data } = useThrottledLoading(!!loading, options);
    const prevDataLengthRef = useRef(0);
    const desiredListLength = useMemo(() => {
        const length = data?.length ?? 0;
        if (length > prevDataLengthRef.current) {
            prevDataLengthRef.current = length;
        }
        return prevDataLengthRef.current;
    }, [data?.length]);
    return (React.createElement(SelectListBox, { id: listId, dataAutomation: `${dataAutomation}/list-box`, onScrollRevealLastItem: onScrollRevealLastItem, options: data || [], emptyState: emptyState, state: listState, label: listBoxLabel, shouldUseVirtualFocus: !!filterInput, loading: loading === 'list-skeleton', desiredListLength: desiredListLength }));
};
//# sourceMappingURL=select-list-box.component.js.map